var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.949V8.051C25.14 8.282 26 9.293 26 10.5C26 11.707 25.14 12.717 24 12.949ZM22 14C22 17.308 19.309 20 16 20C12.691 20 10 17.308 10 14V5C10 4.449 10.449 4 11 4H21C21.551 4 22 4.449 22 5V14ZM19 26C19.551 26 20 26.448 20 27V28H12V27C12 26.448 12.449 26 13 26H19ZM6 10.5C6 9.293 6.86 8.282 8 8.051V12.949C6.86 12.717 6 11.707 6 10.5ZM24 6.051V5C24 3.345 22.654 2 21 2H11C9.346 2 8 3.345 8 5V6.051C5.756 6.303 4 8.19 4 10.5C4 12.832 5.79 14.733 8.064 14.956C8.5 18.587 11.374 21.475 15 21.93V24H13C11.346 24 10 25.345 10 27V29C10 29.553 10.448 30 11 30H21C21.552 30 22 29.553 22 29V27C22 25.345 20.654 24 19 24H17V21.93C20.626 21.475 23.502 18.588 23.938 14.956C26.211 14.732 28 12.831 28 10.5C28 8.19 26.244 6.303 24 6.051Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.b5bc36a12452dfbbe865bde3f1ce4e41.svg";
export { ForwardRef as ReactComponent };